const optionHaystack = (option) => [option.label, option.group ?? "", ...(option.keywords ?? [])]
    .join(" ")
    .toLowerCase();
export const filterSearchableSelectOptions = (options, searchQuery) => {
    const query = searchQuery.trim().toLowerCase();
    if (query.length === 0) {
        return options;
    }
    return options.filter((option) => optionHaystack(option).includes(query));
};
export const groupSearchableSelectOptions = (options) => {
    const hasGroups = options.some((option) => option.group !== undefined && option.group.trim().length > 0);
    if (!hasGroups) {
        return options.length === 0 ? [] : [[undefined, options]];
    }
    const groups = new Map();
    const ungrouped = [];
    for (const option of options) {
        const group = option.group?.trim();
        if (group === undefined || group.length === 0) {
            ungrouped.push(option);
            continue;
        }
        const existing = groups.get(group);
        if (existing === undefined) {
            groups.set(group, [option]);
        }
        else {
            existing.push(option);
        }
    }
    const sortedGroups = [...groups.entries()].sort(([left], [right]) => left.localeCompare(right));
    if (ungrouped.length === 0) {
        return sortedGroups;
    }
    return [[undefined, ungrouped], ...sortedGroups];
};
//# sourceMappingURL=SearchableSelect.utils.js.map